// userService.js
import { get, post, patch, Delete } from './common';


export const expertiseList = (filterData, headers ) => {
    return get('expertise', filterData, headers);
};

export const singleExpertise = (id) => {
  return get('expertise/'+id);
};

export const deleteExpertise = (id) => {
  return Delete('expertise/'+id);
};

// export const addExpertise = (data) => {
//   return post('expertise', data);
// };

export const updateImages = (id, data) => {
  return patch('expertise/'+id+'/images', data, { "content-type": "multipart/form-data"});
}


export const updateAssignment = (id, data) => {
  return post('expertise/'+id+'/assign', data);
}


export const addExpertise = (data) => {
  return post('expertise', data, { "content-type": "multipart/form-data"});
}


export const createExpertise = (data) => {
  return post('expertise/create', data, { "content-type": "multipart/form-data"});
}

export const updateFullExpertise = (id, data) => {
  return post('expertise/update/'+id, data, { "content-type": "multipart/form-data"});
}


export const updateExpertise = (expertiseId, data) => {
  return patch('expertise/'+expertiseId, data);
};

export const getSingleExpertise = (expertiseId) => {
  return get('expertise/'+expertiseId);
};

export const getExpertiseByAdmin = (adminId, filter) => {
  return get('expertise/by-admin/'+adminId, filter);
};


